interface DefaultContainerProps {
	headerContent: React.ReactNode;
	children: React.ReactNode;
}

function DefaultContainer({ headerContent, children }: DefaultContainerProps) {
	return (
		<div className="generic-container" style={{ overflow: "auto" }}>
			<div
				className="project-header"
				style={{ justifyContent: "space-between" }}
			>
				{headerContent}
			</div>
			<div
				style={{
					height: "100%",
					overflow: "auto",
					backgroundColor: "var(--side-container-bg)",
					color: "var(--container-text-color)",
					boxShadow:
						"0px 2px 4px -1px rgba(20, 62, 98, 0.15),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
				}}
			>
				{children}
			</div>
		</div>
	);
}

export default DefaultContainer;
